const COLORS ={
    headerBG:"#153d77",
    hearderTXT:"#fff"
}

export default COLORS